/**
 * @module common/components/single_entry
 */
import React, { Component, PropTypes } from 'react';

/**
 * Abstract single entry modal component. Should be extended.
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class SingleEntry extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPreloader: false,
    };

    this.nextPage = this.nextPage.bind(this);
    this.prevPage = this.prevPage.bind(this);
  }

  /*
   * Abstract function. Should fetch previous entry and return a promise.
   */
  onPrevPage() {}

  /*
   * Abstract function. Should fetch next entry and return a promise.
   */
  onNextPage() {}

  /*
   * Function that controls the preloader when entry page is changed.
   */
  nextPage(e) {
    e.preventDefault();

    const { itemsCount, currentPage } = this.props;
    const pageNum = currentPage + 1;

    if (pageNum < itemsCount + 1) {
      this.setState({
        showPreloader: true,
      });

      this.onNextPage(pageNum);
    }
  }

  /*
   * Function that controls the preloader when entry page is changed.
   */
  prevPage(e) {
    e.preventDefault();
    const { currentPage } = this.props;
    const pageNum = currentPage - 1;

    if (pageNum >= 1) {
      this.setState({
        showPreloader: true,
      });

      this.onPrevPage(pageNum);
    }
  }

  render(children) {
    const childElements = children || [];

    return (
      <div className="single-entry-modal">
        <div className="entry-modal-content">
          { childElements.map(child => child) }
        </div>
      </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {number} itemsCount - total number of elements
 * @property {number} currentPage - current page number for the details view
 */
SingleEntry.propTypes = {
  itemsCount: PropTypes.number,
  currentPage: PropTypes.number,
};



// WEBPACK FOOTER //
// ./common/components/modal/single_entry.jsx